import {
    Box,
    Grid,
    useTheme
} from '@mui/material';
import HeroDescription from './hero-description';
import HeroImage from './hero-image';

const HeroLayout = () => {
    const theme = useTheme();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    pb: {xs: 3, md: 5}
                }}
                className="navigationTopSpacing"
            >
                <Grid
                    direction='row'
                    alignItems='center'
                    container
                    className="bodySideMargin1 sectionRadius sectionInSidePadding"
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        mt: 2
                    }}
                    spacing={5}
                >
                    <Grid
                        size={{xs: 12, lg: 6}}
                    >
                        <HeroDescription />
                    </Grid>

                    <Grid
                        size={{xs: 12, lg: 6}}
                    >
                        <HeroImage />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default HeroLayout;